import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { getExperiments } from '../ExperimentDAO';
import { listS3Objects, parseMillisDifference } from '../dao';


export const fetchFiles = createAsyncThunk(
  'fetchFiles',
  async () => {
    return await listS3Objects();
  },
)

export const fetchExperiments = createAsyncThunk(
  'fetchExperiments',
  async (s3Files) => {
    return await getExperiments(s3Files);
  },
)

const initialState = {
  s3Files: [],
  experiments: [],
  selectedExperiment: null,
};

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    resetStore(state) {
      state.s3Files = []
      state.experiments = []
      state.selectedExperiment = null
    },
    setCurrentExperiment(state, payload) {
      let timestamp = payload.payload
      for (let experiment of state.experiments) {
        if (experiment.timestamp == timestamp) {
          state.selectedExperiment = experiment
          break
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFiles.fulfilled, (state, action) => {
      state.s3Files = action.payload
    })
      .addCase(fetchExperiments.fulfilled, (state, action) => {
        state.experiments = action.payload
      })
  },
})

export const { resetStore, setCurrentExperiment } = experimentsSlice.actions

export default experimentsSlice.reducer

export const selectExperiments = state => state.experiments.experiments
export const selectCurrentExperiment = state => state.experiments.selectedExperiment
export const selectFiles = state => state.experiments.s3Files
export const selectPieChart = createSelector([selectExperiments], (experiments) => {
  let flagged_num = 0;
  let active_num = 0;
  let completed_num = 0;
  for (let ind in experiments) {
    let exp = experiments[ind];
    if (exp.status === "Complete") { completed_num += 1; }
    else if (exp.status === "Flagged") { flagged_num += 1; }
    else { active_num += 1; }
  }

  if (flagged_num + active_num + completed_num === 0) {
    return null;
  }

  return [
    { name: 'Flagged', y: flagged_num },
    { name: 'Running', y: active_num },
    { name: 'Complete', y: completed_num }
  ];
})
export const selectAvglength = createSelector([selectExperiments], (experiments) => {
  if (experiments) {
    let total = 0;
    for (let ind in experiments) {
      let exp = experiments[ind];
      let len = exp.length();
      total += len ? len : 0;
    }
    return parseMillisDifference(total / experiments.length);
  }
})
